export const DIRECTION_OPTIONS = [
  { value: "reduce", label: "reduce" },
  { value: "increase", label: "increase" }
];

export const TYPE_OPTIONS = [
  { value: "standard", label: "standard" },
  { value: "auto_opt_in", label: "auto opt-in" }
];

export const CRITERIA_TAG_FIELDS = [
  {
    key: "vendorId",
    title: "Vendor IDs",
    placeholder: "Enter vendor ID"
  }
];

export const CRITERIA_TYPEAHEAD_FIELDS = [
  {
    key: "vendorAttributeId",
    title: "Vendor Attribute IDs",
    placeholder: "Search vendor attributes by name"
  },
  {
    key: "joroSubcategoryId",
    title: "Joro Subcategory IDs",
    placeholder: "Search subcategories by name"
  }
];

export const CRITERIA_ID_FIELDS = [
  ...CRITERIA_TAG_FIELDS,
  ...CRITERIA_TYPEAHEAD_FIELDS
];
